/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Random {
  /**
   * A random real number between and including the start and end value
   *
   * @public
   * @function f1.random
   * @param start the first number (inclusive)
   * @param end the last number (inclusive)
   * @example
   *
   * ```ts
   * f1.random(3, 5) => 4.34
   * ```
   */
  (start: number, end: number): number;
  /**
   * {@link FnRandomValue}
   * @param start the first number (inclusive)
   */
  (start: number): (end: number) => number;
}

/**
 * @see Random
 */
export default (start: number, end: number) => {
  return Math.random() * (end - start) + start;
};
